import {useMaterialAPI } from "../../../api/material/useMaterialAPI";
import { materialInActions } from "./MaterialInReducer";


export const useMaterialIn= () => {
    const api = useMaterialAPI();
  
    const request = {
        get: (params) => {
          return async (dispatch) => {
            try {
              const response = await api.materialIn.get(params);
              dispatch(materialInActions.funGetmaterialIn(response));
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.materialIn.post(data);
        },
        put: async (data) => {
          return await api.materialIn.put(data);
        },
        delete: async (params) => {
          return await api.materialIn.delete(params);
        }
    };
    return { request };
  };